import { CKEditorComponent } from './ckeditor.component'
import { MultiSelectComponent } from './multi-select.component'
import { MultiSelectGroupComponent } from './multi-select-group.component'
import { MultiSelectOptionComponent } from './multi-select-option.component'
import { SingleSelectComponent } from './single-select.component'
import { SingleSelectOptionComponent } from './single-select-option.component'
import { ToggleSwitchComponent } from './toggle-switch.component'
import { CentersSelectComponent } from './centers-select.component'
import { DateRangeComponent } from './date-range.component'
import { ShowErrorsComponent } from './show-errors.component'
import { NumberSelectComponent } from '../../pages/admin/online-sessions/number-select.component'
import { FlatSelectComponent } from './flat-select.component'
import { ModalStaticTextComponent } from './modal-static-text.component'
import { RatingControlComponent } from './rating-control.component'
import { ControlHintComponent } from './control-hint.component'
import { FastMultiselectComponent } from "./fast-multiselect/fast-multiselect.component"
import { FastMultiselectOptionComponent } from "./fast-multiselect/fast-multiselect-option.component"

export {
  CKEditorComponent,
  MultiSelectComponent,
  MultiSelectGroupComponent,
  MultiSelectOptionComponent,
  SingleSelectComponent,
  SingleSelectOptionComponent,
  ToggleSwitchComponent,
  CentersSelectComponent,
  DateRangeComponent,
  ShowErrorsComponent,
  NumberSelectComponent,
  FlatSelectComponent,
  ModalStaticTextComponent,
  ControlHintComponent,
  RatingControlComponent,
  FastMultiselectComponent,
  FastMultiselectOptionComponent
}

export const FORM_COMPONENTS = [
  CKEditorComponent,
  MultiSelectComponent,
  MultiSelectGroupComponent,
  MultiSelectOptionComponent,
  SingleSelectComponent,
  SingleSelectOptionComponent,
  ToggleSwitchComponent,
  CentersSelectComponent,
  DateRangeComponent,
  ShowErrorsComponent,
  NumberSelectComponent,
  FlatSelectComponent,
  ModalStaticTextComponent,
  ControlHintComponent,
  RatingControlComponent,
  FastMultiselectComponent,
  FastMultiselectOptionComponent
]



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/forms/index.ts